import React       from 'react';
import ReactDom    from 'react-dom';
import Moment      from 'moment';
import Const       from 'fw_const';
import Utils       from 'utils';
import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';
// -------------------------------------------------------


// ワークフュービュー設定
const WORKFLOW_VIEWS = [
  { val: 'all',     label: '全て',                         icon: 'list'          },
  { val: 'casting', label: 'キャスティング対象のみ',         icon: 'stars'         },
  { val: 'assign',  label: 'アサイン対象・候補のみ',        icon: 'person_search' },
  { val: 'draft',   label: '下書き対象のインフルエンサー',     icon: 'edit_note'     },
  { val: 'report',  label: 'レポート対象のインフルエンサー', icon: 'bar_chart'     },
];

const DEFAULT_VIEW = 'all';

// data.workflow.view_status.mode からデフォルト値を安全に取得
function resolveInitialView(data) {
  try {
    const mode = data.workflow.view_status.mode;
    if (mode && WORKFLOW_VIEWS.some(v => v.val === mode)) return mode;
  } catch(e) {}
  return DEFAULT_VIEW;
}

// -------------------------------------------------------
class ProjectHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuOpen:    false,
      currentView: resolveInitialView(props.data),
    };
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleOutsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleOutsideClick);
  }

  handleOutsideClick(e) {
    if (this.menuRef && !this.menuRef.contains(e.target)) {
      this.setState({ menuOpen: false });
    }
  }

  handleViewChange(val) {
    this.setState({ currentView: val, menuOpen: false });

    let data = this.props.data;
    Utils.request.bind(this)('/api/project/workflow/change_workflow_view',
      { project_id: data.project.id, view: val },
      function(res) {
        data.event.updateData('workflow', res.body.workflow);
      }.bind(this)
    );
  }

  render() {
    let data = this.props.data;
    const { menuOpen, currentView } = this.state;

    // カスタムURL
    let custom_urls = [];
    try { if( data.project.detail.custom_urls != null ) custom_urls = JSON.parse(data.project.detail.custom_urls); } catch(e) {}

    const current = WORKFLOW_VIEWS.find(v => v.val === currentView) || WORKFLOW_VIEWS[0];

    const styles = {
      viewSwitcher: {
        position: 'absolute',
        display:  'inline-block',
        top:      '6px',
        right:    '130px',
      },
      viewLabel: {
        display:      'block',
        fontSize:     '9px',
        color:        'rgba(0,0,0,0.45)',
        marginBottom: '2px',
        letterSpacing: '0.04em',
        lineHeight:   1,
        paddingLeft:  '2px',
      },
      viewBtn: {
        display:      'flex',
        alignItems:   'center',
        gap:          '4px',
        padding:      '4px 10px',
        border:       '1px solid rgba(0,0,0,0.2)',
        borderRadius: '4px',
        background:   'transparent',
        cursor:       'pointer',
        fontSize:     '13px',
        color:        'inherit',
        whiteSpace:   'nowrap',
      },
      dropdownMenu: {
        position:     'absolute',
        top:          'calc(100% + 6px)',
        right:        0,
        background:   '#fff',
        border:       '1px solid rgba(0,0,0,0.15)',
        borderRadius: '6px',
        boxShadow:    '0 4px 12px rgba(0,0,0,0.12)',
        zIndex:       200,
        minWidth:     '220px',
        overflow:     'hidden',
      },
      menuItem: {
        display:    'flex',
        alignItems: 'center',
        gap:        '8px',
        padding:    '9px 14px',
        cursor:     'pointer',
        fontSize:   '13px',
        color:      '#333',
        whiteSpace: 'nowrap',
      },
      menuItemActive: {
        background: '#e8f0fe',
        color:      '#1a73e8',
      },
    };

    return (
      <div className="project-header">
        <div className="project-title">
          <a href="/"><i className="material-icons">chevron_left</i></a>
          <p>{data.project.title}</p>
        </div>

        { (data.event.refreshProject != undefined) &&
          <OverlayTrigger placement="left" delayShow={50} overlay={<Tooltip>リフレッシュ</Tooltip>}>
            <div className="refresh-box" onClick={data.event.refreshProject.bind(this)}>
              <i className="material-icons">refresh</i>
            </div>
          </OverlayTrigger>
        }

        { (custom_urls.length > 0) &&
          <div className="custom-urls">
            { custom_urls.map((d, key) => {
              if( d.name == '' || d.url == '' ) return null;
              return (
                <OverlayTrigger key={key} placement="top" delayShow={50} overlay={<Tooltip>{d.name}</Tooltip>}>
                  <a href={d.url} target="_blank">
                    <i className="material-icons">link</i>
                  </a>
                </OverlayTrigger>
              );
            })}
          </div>
        }

        {/* ワークフュービュー切り替えボタン */}
        <div
          style={styles.viewSwitcher}
          ref={ref => { this.menuRef = ref; }}
        >
          <span style={styles.viewLabel}>表示形式</span>
          <OverlayTrigger placement="bottom" delayShow={50} overlay={<Tooltip>表示切り替え</Tooltip>}>
            <button
              style={styles.viewBtn}
              onClick={() => this.setState(s => ({ menuOpen: !s.menuOpen }))}
            >
              <i className="material-icons" style={{ fontSize: '18px' }}>{current.icon}</i>
              <span>{current.label}</span>
              <i className="material-icons" style={{ fontSize: '16px' }}>arrow_drop_down</i>
            </button>
          </OverlayTrigger>

          { menuOpen && (
            <div style={styles.dropdownMenu}>
              { WORKFLOW_VIEWS.map(v => {
                const isActive = v.val === currentView;
                return (
                  <div
                    key={v.val}
                    style={{
                      ...styles.menuItem,
                      ...(isActive ? styles.menuItemActive : {}),
                    }}
                    onClick={() => this.handleViewChange(v.val)}
                    onMouseEnter={e => { if (!isActive) e.currentTarget.style.background = '#f5f5f5'; }}
                    onMouseLeave={e => { if (!isActive) e.currentTarget.style.background = 'transparent'; }}
                  >
                    <i className="material-icons" style={{ fontSize: '18px' }}>{v.icon}</i>
                    {v.label}
                  </div>
                );
              })}
            </div>
          )}
        </div>

        <a href={'/project-create/'+ data.project.unique_code }>
          <div className="setting button">
            <i className="material-icons">settings</i>設定
          </div>
        </a>
      </div>
    );
  }
}
// -------------------------------------------------------
export default ProjectHeader;